var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { ServiceDescriptor } from "./../models/V1/Services/V2/ServiceDescriptor";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class Services {
  /**
   * Creates an instance of Services.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof Services
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetAvailableServicesRq_ _getAvailableServicesRq
   * @returns Promise<GetAvailableServicesRq_>
   * @memberof Services
   */
  getAvailableServices(pGetAvailableServicesRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Services/available", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pGetAvailableServicesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: ServiceDescriptor, isArray: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
